import { SVGProps } from "react";

const IconPromotionBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M12.00,2.50L14.02,4.47L16.75,3.77L17.52,6.48L20.23,7.25L19.53,9.98L21.50,12.00L19.53,14.02L20.23,16.75L17.52,17.52L16.75,20.23L14.02,19.53L12.00,21.50L9.98,19.53L7.25,20.23L6.48,17.52L3.77,16.75L4.47,14.02L2.50,12.00L4.47,9.98L3.77,7.25L6.48,6.48L7.25,3.77L9.98,4.47Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <circle cx="9.4" cy="9.1" r="1.55" stroke="currentColor" strokeWidth="1.2" />
    <circle cx="14.6" cy="14.9" r="1.55" stroke="currentColor" strokeWidth="1.2" />
    <path d="M15.3 8.7 8.7 15.3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export default IconPromotionBadge;
